import { create } from "zustand";
/** Çizim–panel bağlantısı: vurgulu kuvvet (sonuç tablosu ↔ ok) ve vurgulu ölçü (geometri alanı ↔ ölçü çizgisi). */
export const useHighlight = create<{ forceId: string | null; dimKey: string | null; set: (id: string | null) => void; setDim: (key: string | null) => void }>((set) => ({
  forceId: null, dimKey: null,
  set: (forceId) => set({ forceId }),
  setDim: (dimKey) => set({ dimKey }),
}));
